import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { 
  Box, 
  CardContent, 
  Typography, 
  Button
} from '@mui/material';
import { 
  Add as AddIcon, 
  Policy as PolicyIcon
} from '@mui/icons-material';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { PolicyGrid } from '../components/grids';

const Policies: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const company = searchParams.get('company') || '';

  const handleNewPolicy = () => {
    const params = new URLSearchParams();
    if (company) params.append('company', company);
    navigate(`/case-management/policy-create?${params.toString()}`);
  };

  if (!company) {
    return (
      <PageContainer>
        <Box display="flex" justifyContent="center">
          <PageCard sx={{ maxWidth: 800 }}>
            <CardContent sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" color="error">
                No company specified. Please select a company to view policies.
              </Typography>
            </CardContent>
          </PageCard>
        </Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Professional Header */}
          <Box sx={{ 
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 20
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <PolicyIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
              <Box>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    fontWeight: 600, 
                    color: '#1e293b',
                    mb: 0.5
                  }}
                >
                  Policies Management
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ color: '#64748b' }}
                >
                  Manage policies for {company}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleNewPolicy}
                sx={{ 
                  backgroundColor: '#162346',
                  '&:hover': {
                    backgroundColor: '#1a2a52'
                  },
                  fontWeight: 600
                }}
              >
                New Policy
              </Button>
            </Box>
          </Box>
          
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            <PolicyGrid />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default Policies;
